
export default {
  placeDetails: {
    'layer': 'Réteg',
    'lat': 'Szél.',
    'lon': 'Hossz.',
    'notAvailable': 'Nem elérhető',
    'placeDetails': 'Hely adatai',
    'placeName': 'Név',
    'latlngCopied': 'Szélesség és hosszúság másolva',
    'lnglatCopied': 'Hosszúság és szélesség másolva',
    'copyLatlng': 'Másolás szélesség-hosszúság formátumban',
    'copyLnglat': 'Másolás hosszúság-szélesség formátumban',
    'satelliteView': 'műholdas nézet'
  }
}
